// extracted by mini-css-extract-plugin
export default {"title":"CustomSlider_title__ErFnJ","rc-slider":"CustomSlider_rc-slider__EcTh4","rc-slider-mark-tex":"CustomSlider_rc-slider-mark-tex__FIq2i"};